 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import A0_FRONTCOVER from '@/components/00_frontcover'
 import A1_DEDICATION from '@/components/01_dedication'
 import A2_TITLE from '@/components/02_title'
 import A2A_COPY from '@/components/02a_copy'
 import A3_CONTENTS from '@/components/03_contents'
 import A4_MAPS from '@/components/04_maps'
 import A5_PLATES from '@/components/05_plates'
 import A6_ACKNOWLEDGEMENTS from '@/components/06_acknowledgements'
 import A7_CONTRIBUTORS from '@/components/07_contributors'
 import A8_INTRODUCTION from '@/components/08_introduction'
 import A9_CHAPTER01 from '@/components/09_chapter01'
 import A0_CHAPTER011 from '@/components/10_chapter011'
 import A1_CHAPTER012 from '@/components/11_chapter012'
 import A2_CHAPTER02 from '@/components/12_chapter02'
 import A3_CHAPTER021 from '@/components/13_chapter021'
 import A4_CHAPTER022 from '@/components/14_chapter022'
 import A5_CHAPTER03 from '@/components/15_chapter03'
 import A6_CHAPTER031 from '@/components/16_chapter031'
 import A7_CHAPTER032 from '@/components/17_chapter032'
 import A8_CHAPTER04 from '@/components/18_chapter04'
 import A9_CHAPTER041 from '@/components/19_chapter041'
 import A0_CHAPTER042 from '@/components/20_chapter042'
 import A1_CHAPTER043 from '@/components/21_chapter043'
 import A2_CHAPTER044 from '@/components/22_chapter044'
 import A3_CHAPTER045 from '@/components/23_chapter045'
 import A4_CHAPTER046 from '@/components/24_chapter046'
 import A5_CHAPTER047 from '@/components/25_chapter047'
 import A6_CHAPTER048 from '@/components/26_chapter048'
 import A7_CHAPTER049 from '@/components/27_chapter049'
 import A8_CHAPTER0410 from '@/components/28_chapter0410'
 import A9_CHAPTER0411 from '@/components/29_chapter0411'
 import A0_CHAPTER0412 from '@/components/30_chapter0412'
 import A1_CHAPTER0413 from '@/components/31_chapter0413'
 import A2_CHAPTER0414 from '@/components/32_chapter0414'
 import A3_CHAPTER05 from '@/components/33_chapter05'
 import A4_CHAPTER051 from '@/components/34_chapter051'
 import A5_CHAPTER052 from '@/components/35_chapter052'
 import A6_CHAPTER06 from '@/components/36_chapter06'
 import A7_CHAPTER061 from '@/components/37_chapter061'
 import A8_CHAPTER062 from '@/components/38_chapter062'
 import A9_CHAPTER063 from '@/components/39_chapter063'
 import A0_CHAPTER064 from '@/components/40_chapter064'
 import A1_CHAPTER07 from '@/components/41_chapter07'
 import A2_CHAPTER071 from '@/components/42_chapter071'
 import A3_CHAPTER072 from '@/components/43_chapter072'
 import A4_CHAPTER073 from '@/components/44_chapter073'
 import A5_CHAPTER074 from '@/components/45_chapter074'
 import A6_CHAPTER075 from '@/components/46_chapter075'
 import A7_CHAPTER076 from '@/components/47_chapter076'
 import A8_CHAPTER08 from '@/components/48_chapter08'
 import A9_CHAPTER081 from '@/components/49_chapter081'
 import A0_CHAPTER082 from '@/components/50_chapter082'
 import A1_CHAPTER083 from '@/components/51_chapter083'
 import A2_CHAPTER084 from '@/components/52_chapter084'
 import A3_CHAPTER085 from '@/components/53_chapter085'
 import A4_CHAPTER086 from '@/components/54_chapter086'
 import A5_APPENDIX from '@/components/55_appendix'
 import A6_NOTES from '@/components/56_notes'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/03_contents",
 			"name" : "03_contents",
 			"component" : A3_CONTENTS
 		},
 		{
 			"path" : "/04_maps",
 			"name" : "04_maps",
 			"component" : A4_MAPS
 		},
 		{
 			"path" : "/05_plates",
 			"name" : "05_plates",
 			"component" : A5_PLATES
 		},
 		{
 			"path" : "/06_acknowledgements",
 			"name" : "06_acknowledgements",
 			"component" : A6_ACKNOWLEDGEMENTS
 		},
 		{
 			"path" : "/07_contributors",
 			"name" : "07_contributors",
 			"component" : A7_CONTRIBUTORS
 		},
 		{
 			"path" : "/08_introduction",
 			"name" : "08_introduction",
 			"component" : A8_INTRODUCTION
 		},
 		{
 			"path" : "/09_chapter01",
 			"name" : "09_chapter01",
 			"component" : A9_CHAPTER01
 		},
 		{
 			"path" : "/10_chapter011",
 			"name" : "10_chapter011",
 			"component" : A0_CHAPTER011
 		},
 		{
 			"path" : "/11_chapter012",
 			"name" : "11_chapter012",
 			"component" : A1_CHAPTER012
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js